// extracted by mini-css-extract-plugin
export default {"input":"RenameFileInput_input__uablu","extension":"RenameFileInput_extension__9mG0T"};